import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
    position: sticky;
    top: 0;
    z-index: 100;
  }

  .header {
    background: white;
    border-bottom: 1px solid var(--sl-color-neutral-200);
    padding: 0.5rem 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 48px;
    box-shadow: var(--sl-shadow-small);
    position: relative;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex: 1;
  }

  .header-center {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex: 1;
    justify-content: flex-end;
  }

  .sidebar-toggle {
    --sl-color-neutral-600: var(--sl-color-neutral-500);
  }

  .sidebar-toggle::part(base) {
    padding: 0.5rem;
  }

  .logo {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    cursor: pointer;
    padding: 0.5rem;
    border-radius: var(--sl-border-radius-medium);
    transition: background-color 0.2s ease;
  }

  .logo:hover {
    background-color: var(--sl-color-neutral-100);
  }

  .logo-image {
    width: 32px;
    height: 32px;
    border-radius: var(--sl-border-radius-medium);
  }

  .logo-text {
    margin: 0;
    font-size: 1.125rem;
    font-weight: 600;
    color: var(--sl-color-primary-600);
  }

  .page-title {
    margin-left: 1rem;
    padding-left: 1rem;
    border-left: 1px solid var(--sl-color-neutral-200);
  }

  .page-title h2 {
    margin: 0;
    font-size: 1.125rem;
    font-weight: 500;
    color: var(--sl-color-neutral-700);
  }


  .user-info {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .user-name {
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--sl-color-neutral-900);
    line-height: 1.2;
  }

  .user-email {
    font-size: 0.75rem;
    color: var(--sl-color-neutral-500);
    line-height: 1.2;
  }

  .subscription-badge {
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.025em;
  }

  .subscription-badge::part(base) {
    border-radius: var(--sl-border-radius-medium);
    padding: 0.25rem 0.5rem;
  }

  /* Responsive design */
  @media (max-width: 768px) {
    .page-title {
      display: none;
    }

    .logo-text {
      display: none;
    }

    .user-info {
      display: none;
    }

    .subscription-badge {
      font-size: 0.6rem;
      padding: 0.125rem 0.25rem;
    }

    .user-menu {
      min-width: 240px;
    }
  }

  @media (max-width: 480px) {
    .header {
      padding: 0.5rem 1rem;
    }

    .logo-image {
      width: 32px;
      height: 32px;
    }

    .user-avatar {
      width: 28px;
      height: 28px;
      font-size: 0.75rem;
    }
  }
`;
